import logo from "../assets/nbn logo.png";
import arrowup from "../assets/arrowup.png";
import { useAppContext } from "../AppContext";
import StripePayment from "./StripePayment";

const Header = () => {
  const { setBuyNow, buyNow, loadingHeader } = useAppContext();

  return (
    <div className="bg-[#F8F8F8]">
      <div className="relative z-10 container mx-auto py-16">
        <div className="block lg:flex max-w-6xl mx-auto">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="mb-">
              <img src={logo} width={500} />
              <div className="mt-8 gap-2 p-3">
                <p className="text-3xl text-[#F09900] font-semibold mb-2">
                  <span className="text-[#4E6978]"> 500 </span>New Business
                  Leads
                  <p className="text-[#4E6978]">for $200</p>
                </p>
                <div className="mt-6">
                  <p className="text-[#4E6978] text-2xl font-semibold">
                    <span className="text-[#F09900]">100% Verified</span> New
                    Business Leads
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 text-base text-gray-600 font-medium py-3 px-5">
              <img src={arrowup} width={30} />
              <span className="text-[#4E6978] font-semibold italic ml-3">
                The Commercial Cleaning Marketing <br />
                Made Easy Marketing Kit
              </span>
            </div>
            <div className="flex items-center gap-2 text-base text-gray-600 mt-2 font-medium py-3 px-5">
              <img src={arrowup} width={30} />

              <span className="text-[#4E6978] font-semibold italic ml-3">
                Bonus Postcard, Brochure, and <br />
                Voice Mail Script
              </span>
            </div>
          </div>

          {/* Right Form */}
          {buyNow === "home" && (
            <div className="py-3 px-4 md:py-0 md:px-0 flex-shrink-0 md:min-w-lg lg:min-w-lg w-full lg:w-80">
              <div className="bg-white rounded shadow-2xl overflow-hidden border-2 border-[#4E6978]">
                <div className="flex">
                  <button className="flex-1 bg-[#4E6978] text-white py-5 px-4 font-semibold">
                    <span className="text-white text-xl">Zip Code</span>
                  </button>
                </div>

                <div className="p-6 px-7">
                  <p className="text-2xl font-bold text-[#4E6978] text-center font-semibold">
                    Get Your List Now
                  </p>
                  <div></div>
                  <p className="text-md text-[#4E6978] mb-6">
                    I would like 500 new business records around my zipcode
                  </p>

                  <div className="space-y-4">
                    <div className="mt-6">
                      <button
                        type="submit"
                        className="w-full bg-[#F09900] hover:bg-yellow-600 text-white font-bold py-4 transition-colors border-2 border-[#4E6978] cursor-pointer"
                        style={{ color: "white", fontSize: "20px" }}
                        onClick={() => setBuyNow("payment")}
                      >
                        Buy Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {loadingHeader && (
            <div className="flex items-center min-h-screen">
              <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
            </div>
          )}

          {(buyNow === "payment" || buyNow === "download") && <StripePayment />}
        </div>
      </div>
    </div>
  );
};

export default Header;
